function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M7 0a7 7 0 107 7 7.008 7.008 0 00-7-7zm0 12a5 5 0 115-5 5 5 0 01-5 5zM6 6.96L4.16 8.77 5.76 10l2-2H8V4H6v2.96z",
  fill: "#a6a6a6",
  fillRule: "evenodd"
});

var SvgIconClockGrey = function SvgIconClockGrey(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNCIgaGVpZ2h0PSIxNCIgdmlld0JveD0iMCAwIDE0IDE0Ij4KICA8ZGVmcz4KICAgIDxzdHlsZT4KICAgICAgLmNscy0xIHsKICAgICAgICBmaWxsOiAjYTZhNmE2OwogICAgICAgIGZpbGwtcnVsZTogZXZlbm9kZDsKICAgICAgfQogICAgPC9zdHlsZT4KICA8L2RlZnM+CiAgPHBhdGggaWQ9IlRpbWUtSWNvbi5zdmciIGNsYXNzPSJjbHMtMSIgZD0iTTE1MjMsMTQ1M2E3LDcsMCwxLDAsNyw3QTcuMDA4LDcuMDA4LDAsMCwwLDE1MjMsMTQ1M1ptMCwxMmE1LDUsMCwxLDEsNS01QTUsNSwwLDAsMSwxNTIzLDE0NjVabS0xLTUuMDQtMS44NCwxLjgxLDEuNiwxLjIzLDItMkgxNTI0di00aC0ydjIuOTZaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTUxNiAtMTQ1MykiLz4KPC9zdmc+Cg==";
export { SvgIconClockGrey as ReactComponent };